import { h } from 'preact'
import { map, values, pipe, sort, mergeAll, assoc, take } from 'ramda'
import FirebaseComponent from './FirebaseComponent'
import { dateStatus, daysToDate } from './date-helpers'
import { listenForFirebaseItems } from './firebase-helpers'
import './EventsTable.css'

class EventsTable extends FirebaseComponent {
  constructor() {
		super()
    this.state.events = {}
    this.tableBody = this.tableBody.bind(this)
    this.rowFromEvent = this.rowFromEvent.bind(this)

    listenForFirebaseItems('competencies', _competencies => {
      const setIcon = assoc('icon', 'fa fa-file')
      const competencies = map(setIcon, _competencies)
      this.setState({ competencies })
    })
    listenForFirebaseItems('passports', _passports => {
      const setTitle = p => assoc('title', `${p.countryOfIssue} passport expires`)(p)
      const setIcon = assoc('icon', 'fa fa-address-book')
      const passports = map(pipe(setTitle, setIcon), _passports)
      this.setState({ passports })
    })
    listenForFirebaseItems('visas', _visas => {
      const setTitle = p => assoc('title', `${p.countryOfIssue} visa expires`)(p)
      const setIcon = assoc('icon', 'fa fa-address-card')
      const visas = map(pipe(setTitle, setIcon), _visas)
      this.setState({ visas })
    })
    listenForFirebaseItems('events', _events => {
      const setEndAsStart = e => assoc('endDate', e.startDate)(e)
      const setIcon = assoc('icon', 'fa fa-calendar-o')
      const customEvents = map(pipe(setIcon, setEndAsStart), _events)
      this.setState({ customEvents })
    })
    listenForFirebaseItems('medicals', _medicals => {
      const setTitle = m => assoc('title', `${m.title} expires`)(m)
      const setIcon = assoc('icon', 'fa fa-stethoscope')
      const medicals = map(pipe(setIcon, setTitle), _medicals)
      this.setState({ medicals })
    })
  }

  rowFromEvent(event) {
    return (
      <tr>
        <td clasName="icon-column"><i className={event.icon}></i></td>
        <td>{event.title}</td>
        <td className={dateStatus(event.endDate) + ' days-until-column'}>{daysToDate(event.endDate)}</td>
        <td><a onClick={event.remove}><i className="fa fa-trash-o"></i></a></td>
      </tr>
    )
  }

  tableBody() {
    const events = mergeAll([
      this.state.competencies,
      this.state.passports,
      this.state.visas,
      this.state.customEvents,
      this.state.medicals
    ])

    const byEndDates = (a, b) => daysToDate(a.endDate) - daysToDate(b.endDate)
    const tableRows = pipe(values, sort(byEndDates), take(12), map(this.rowFromEvent))

    return (
      <tbody>
        {tableRows(events)}
      </tbody>
    )
  }

  render() {
    return (
			<div class="heading-container">
				<span class="heading-events">Events and actions points</span>
				<table class="table table-striped table-hover">
          {this.tableBody()}
				</table>
			</div>
    );
  }
}

export default EventsTable



// WEBPACK FOOTER //
// ./src/EventsTable.js